import "../../styles/faqs.css";
import Footer from "../../components/footer";
import Header from "../../components/header";
import FaqsMain from "./faqsMain";
import FaqsCta from "./faqsCta";

function Faqs() {
  return (
    <>
      <Header />
      <FaqsMain />
      <FaqsCta />
      <Footer />
    </>
  );
}

export default Faqs;
